/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 02/12/13
 * Time: 17:49
 */



Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Greenmile.Toolbar.Map = (function () {

    /**
     * ToolbarMap constructor
     * @param {object} pageLayout
     * @constructor
     */
    function ToolbarMap (map, mapSelector, options, help) {

        this.actions = {
            searchAddressOnMap: 'searchAddressOnMap', //busca por endereços
            street: 'street',
            zoom: 'zoom',
            source: 'source',
            points: 'points',
            coords: 'coords',
            layer: 'layer',
            fitToMarkers: 'fitToMarkers',
            routePlayer: 'routePlayer',
            custom: 'custom',
            hos: 'hos',
            pois: 'pois',
            geofences: 'geofences',
            layerPositionHistory: 'layerPositionHistory',
            multiSearchOnMap: 'multiSearchOnMap', // busca por endereços, equipamqntos, motoristas, orders
            searchonmap: 'searchonmap',
            tagsEquipment: 'tagsEquipment',
            tagsGeofence: 'tagsGeofence',
            configInfoMarkerTruck: 'configInfoMarkerTruck',
            events: 'events',
            focusEquipment: 'focusEquipment',
            equipmentOff: 'equipmentOff',
            multiroute: 'multiroute'
        };

        var items = {
            searchAddressOnMap: {
                action: () => {
                    try {
                        return new Greenmile.Toolbar.Map.SearchAddressOnMap(mapSelector, map, options);
                    } catch (ex) {
                        var error = new Monet.Exception.ReturnError(this, 'Error instanciating SearchAddressOnMap of toolbar', ex);
                        error.console();
                    }
                },
                enable: false,
                template: {
                    selector: '#searchAddressOnMap_template',
                    position: 'left'
                }
            },
            multiSearchOnMap: {
                action: () => {
                    try {
                        return new Greenmile.Toolbar.Map.MultiSearchOnMap(mapSelector, map);
                    } catch (ex) {
                        var error = new Monet.Exception.ReturnError(this, 'Error instanciating MultiSearchOnMap of toolbar', ex);
                        error.console();
                    }
                },
                enable: false,
                template: {
                    selector: '#multiSearchOnMap_template',
                    position: 'left'
                }
            },
            street: {
                action: () => {
                    try {
                        return new Greenmile.Toolbar.Map.StreetView("#" + Monet.Utils.GetTabName(), map);
                    } catch (ex) {
                        var error = new Monet.Exception.ReturnError(this, 'Error instanciating StreetView of toolbar', ex);
                        error.console();
                    }
                },
                enable: false,
                template: {
                    selector: '#street_template',
                    position: 'left'
                }
            },
            focusEquipment: {
                action: () => ( new Greenmile.Toolbar.Map.FocusEquipment(mapSelector, map) ),
                enable: false,
                template: {
                    selector: '#focusEquipment_template',
                    position: 'left'
                }
            },
            fitToMarkers: {
                action: () => ( new Greenmile.Toolbar.Map.FitToMarkers(mapSelector, map) ),
                enable: false,
                template: {
                    selector: '#fitToMarkers_template',
                    position: 'left'
                }
            },
            zoom: {
                action: () => ( new Greenmile.Toolbar.Map.ZoomSlider(mapSelector, map) ),
                enable: false,
                template: {
                    selector: '#zoom_template',
                    position: 'left'
                }
            },
            geofences: {
                action: () => ( new Greenmile.Toolbar.Map.GeofencesControl(mapSelector, map) ),
                enable: false,
                template: {
                    selector: '#geofences_template',
                    position: 'right'
                }
            },
            equipmentOff: {
                action: () => ( new Greenmile.Toolbar.Map.EquipmentOff(mapSelector, map, options) ),
                enable: false,
                template: {
                    selector: '#equipamentOff_template',
                    position: 'right'
                }
            },
            hos: {
                action: () => ( new Greenmile.Toolbar.Map.HOSLayerControl(mapSelector, map, options) ),
                enable: false,
                template: {
                    selector: '#hos_template',
                    position: 'right'
                }
            },
            layer: {
                action: () => ( new Greenmile.Toolbar.Map.LayerControl(mapSelector, map, options) ),
                enable: false,
                template: {
                    selector: '#new_layer_template',
                    position: 'right'
                }
            },
            pois: {
                action: () => ( new Greenmile.Toolbar.Map.POISControl(mapSelector, map) ),
                enable: false,
                template: {
                    selector: '#pois_template',
                    position: 'right'
                }
            },
            source: {
                action: () => {
                    try {
                        return new Greenmile.Toolbar.Map.MapSourceControl(mapSelector, map, options);
                    } catch (ex) {
                        var error = new Monet.Exception.ReturnError(this, 'Error instanciating MapSourceControl of toolbar', ex);
                        error.console();
                    }
                },
                enable: false,
                template: {
                    selector: '#source_template',
                    position: 'right'
                }
            },
            multiroute: {
              action: () => {
                  try {
                      const multiroute =  new Greenmile.Toolbar.Map.MultiRouteControl(mapSelector, map, options);

                      return multiroute;
                  } catch (ex) {
                      const error = new Monet.Exception.ReturnError(this, 'Error instanciating MapSourceControl of toolbar', ex);
                      error.console();
                  }
              },
              enable: false,
              template: {
                  selector: '#multiroute_template',
                  position: 'right'
              }
          },
            points: {
                action: () => ( new Greenmile.Toolbar.Map.Points(mapSelector, map) ),
                enable: false,
                template: {
                    selector: '#points_template',
                    position: 'left'
                }
            },
            coords: {
                action: () => ( new Greenmile.Toolbar.Map.DistanceBetweenCoords(mapSelector, map, options) ),
                enable: false,
                template: {
                    selector: '#coords_template',
                    position: 'right'
                }
            },
            routePlayer: {
                action: () => ( new Greenmile.Toolbar.Map.RoutePlay(mapSelector, map, options) ),
                enable: false,
                template: {
                    selector: '#routePlayer_template',
                    position: 'center'
                }
            },
            custom: {
                action: null,
                enable: false,
                template: {
                    selector: '#fitToMarkers_template',
                    position: 'left'
                }
            },
            tagsEquipment: {
                action: () => ( new Greenmile.Toolbar.Map.Tags(map, mapSelector, new Greenmile.Toolbar.Map.TagsEquipmentActions(map, mapSelector)) ),
                enable: false,
                template: {
                    selector: '#tags_template_equipment',
                    position: 'right'
                }
            },
            tagsGeofence: {
                action: () => ( new Greenmile.Toolbar.Map.Tags(map, mapSelector, new Greenmile.Toolbar.Map.TagsGeofenceActions(map, mapSelector)) ),
                enable: false,
                template: {
                    selector: '#tags_template_geofence',
                    position: 'right'
                }
            },
            configInfoMarkerTruck: {
                action: () => ( new Greenmile.Toolbar.Map.ConfigInfoTruckMarker(mapSelector) ),
                enable: false,
                template: {
                    selector: '#config_info_marker_truck',
                    position: 'right'
                }
            },
            events: {
                action: () => ( new Greenmile.Toolbar.Map.Events(mapSelector, map) ),
                enable: false,
                template: {
                    selector: '#config_info_events',
                    position: 'right'
                }
            },
        };


        var afterRenderToolbar = null;

        this.setAfterRenderToolbar = function (f) {

            afterRenderToolbar = f;

        };

        this.loadingLayoutToolbar = function (selector) {


            var layout = {
                items: [
                    {
                        tag: "span",
                        attributes: {
                            id: "toolbar_template"
                        },
                        items: [
                            {
                                attributes: {
                                    "class": "mapToolbarContaineer"
                                },
                                items: [
                                    {
                                        attributes: {
                                            "class": "mapToolBar",
                                            "id": "mapToolBar"
                                        },
                                        items: [
                                            {
                                                attributes: {
                                                    "class": "left",
                                                },
                                            },
                                            {
                                                attributes: {
                                                    "class": "center",
                                                },
                                            },
                                            {
                                                attributes: {
                                                    "class": "right",
                                                },
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            };

            $(selector).prepend((new Monet.UI.LayoutGenerator(layout)).render());

            /*
             * @params id_elemento - só pode ser passado elemento do tipo id
             */
            var id_elemento = document.getElementById("toolbar_template");
            Greenmile.Toolbar.Map.Util.mouseWheelHandler(id_elemento);

        };

        this.addToolbarElement = function (mapSelector, objectActions) {

            if (objectActions && objectActions.action && objectActions.enable) {

                var template = new Greenmile.Toolbar.Map.Components(mapSelector);
                template.render(objectActions.template, objectActions.action());

            }

        };

        this.setProperty = function (id, value) {
            items[id] = value;
        };

        this.enable = function (keys) {
            for (var y in keys) {
                this.setEnable(keys[y], true);
            }

        };

        this.disable = function (keys) {
            for (var z in keys) {
                this.setEnable(keys[z], false);
            }
        };

        this.setEnable = function (id, value) {
            if (id && items[id]) {
                items[id].enable = value;
            }
        };

        this.render = function () {

            this.loadingLayoutToolbar(mapSelector);

            for (var x in items) {
                this.addToolbarElement(mapSelector, items[x]);
            }

            if (help) {

                var mapToolBar = document.querySelector(mapSelector + " #mapToolBar .right");

                if (mapToolBar) {
                    var el = help.render();
                    el.classList.add('onToolbar');
                    el.setAttribute('title', Monet.I18n.getResourcesByKey('Toolbar.hint.help'));
                    mapToolBar.appendChild(el);
                }

            }

            if (afterRenderToolbar) {
                afterRenderToolbar();
            }

        };

    }

    return ToolbarMap;

}());
